import React, { useState } from "react";
import {
  electricityProperties,
  waterProperties,
  gasProperties
} from "./BillInfoProperties";
import { useMediaQuery } from "react-responsive";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls, url } from "../../Utils/url";
import { ReactComponent as Tick } from "../../assets/icons/tick.svg";
import { ReactComponent as Alert } from "../../assets/icons/alert.svg";

const BillWarn =
  "کاربر گرامی پرداخت پیش از اتمام مهلت پرداخت مهم است و واریز پس از این تاریخ ممکن است به عنوان بستانکاری در قبوض بعدی محاسبه شود و در قبض بعدی به عنوان بدهی قبلی درج شود";

export const PayBill = (billId, token, setBtnActive, checked, companyId) => {
  const body = {
    bill_id: billId,
    reminder: checked && (companyId === 4 || companyId === 5) ? 1 : 0
  };
  ApiCall("post", `${urls.Payment}`, body, "payBill", token, function(e) {
    window.open(`${url}Payment/${e.data.invoice_number}`);
    setBtnActive(false);
  });
};

const CompanyImage = companyId => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    default:
      break;
  }
};

const Table = ({ TableData, Info }) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  return isTabletOrMobile && isPortrait ? (
    <table>
      {TableData.map((i, index) => (
        <tr>
          <span>{Info[i.value]}</span>
          <span>{i.title}</span>
        </tr>
      ))}
    </table>
  ) : (
    <table>
      <tbody>
        {TableData.map(
          (i, index) =>
            index % 2 === 0 && (
              <tr key={`#TableInfo${index}`}>
                <td>
                  <span>
                    {TableData[index + 1] && TableData[index + 1].title}
                  </span>
                  <span>
                    {TableData[index + 1] && Info[TableData[index + 1].value]}
                  </span>
                </td>
                <td>
                  <span>{i.title}</span>
                  <span>{Info[i.value]}</span>
                </td>
              </tr>
            )
        )}
      </tbody>
    </table>
  );
};

const BillInfo = ({ name, amount }) => {
  return (
    <div>
      <span>{amount}</span>
      <span>{name}</span>
    </div>
  );
};

const BillInformation = ({
  billId,
  billName,
  companyId,
  amount,
  setState,
  date,
  info,
  header,
  token,
  billParam,
  setBtnActive,
  btnActive,
  paymentStatus
}) => {
  const TableData =
    companyId === 1
      ? waterProperties
      : companyId === 2
      ? gasProperties
      : electricityProperties;
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const [checked, setChecked] = useState(true);
  return (
    <div className="BillInformation">
      <img src={CompanyImage(companyId)} alt="" />
      <h1>{`${header.replace("پرداخت ", "")}`}</h1>
      <div>
        <BillInfo name={":نام مشترک"} amount={billName} />
        <BillInfo name={":شناسه قبض"} amount={billId} />
        <BillInfo name={":مبلغ"} amount={` ${amount.toLocaleString()} ریال `} />
        {date && <BillInfo name={":مهلت پرداخت"} amount={date} />}
      </div>
      {(companyId === 4 || companyId === 5) && (
        <>
          <div className="Reminder" onClick={() => setChecked(!checked)}>
            <span>صدور قبض های بعدی را به من یادآوری کن</span>
            <div>{checked && <Tick />}</div>
          </div>
          <h3>
            با انتخاب گزینه بالا، صدور قبض جدید در ماه های آینده بدون هزینه به
            شما اطلاع رسانی خواهد شد
          </h3>
        </>
      )}
      {(companyId === 1 || companyId === 2 || companyId === 3) && (
        <div className="Warn">
          <Alert />
          <span>{BillWarn}</span>
        </div>
      )}

      {paymentStatus === 1 ? (
        <h2>قبض مورد نظر پرداخت شده است!</h2>
      ) : !(isTabletOrMobile && isPortrait) ? (
        <input
          type="submit"
          className={btnActive ? "LoginButton" : "LoginButton disableBtn"}
          value="پرداخت"
          onClick={() =>
            btnActive &&
            PayBill(billParam, token, setBtnActive, checked, companyId)
          }
        />
      ) : (
        <input
          type="submit"
          className={btnActive ? "PayButton" : "PayButton disableBtn"}
          value="پرداخت"
          onClick={() =>
            btnActive &&
            PayBill(billParam, token, setBtnActive, checked, companyId)
          }
        />
      )}
      {btnActive && (
        <h5 onClick={() => setState(false)}>وارد کردن شناسه دیگر</h5>
      )}
      {(companyId === 1 || companyId === 2 || companyId === 3) && (
        <>
          <h2>جزئیات قبض</h2>
          <Table TableData={TableData} Info={info} />
        </>
      )}
    </div>
  );
};

export default BillInformation;
